
const headers = (t : any) => {
    return [
        // {
        //     label: "",
        //     className: "w-20p",
        //     checkbox: true,
        // },
        // {
        //     label: 'id',
        //     sort: 'id',
        //     className: "w-20p"
        // },
        {
            label: 'Pensopay Payment ID',
            className: "w-10p"
        },
        {
            label: 'Reference',
            className: "w-20p"
        },      {
            label: 'acquirer',
            className: "w-20p"
        },

        {
            label: 'Amount',
            className: "w-20p align-right"
        },
        {
            label: 'Date',
            className: "w-20p"
        },
        // {
        //     label: 'Eco Matching Invoice',
        //     className: "w-20p"
        // },
        {
            label: 'Message',
            className: "w-20p"
        },
        {
            label: 'Status',
            className: "w-20p"
        },


        {
            label: 'Created',
            sort: 'created_at',
            className: "w-20p"
        },
    ]
}

export const PaymentConfig = {
    headers,
}
